(function(){
  /* copy: internal — buy-path JS, not persuasion.
     MODE-AWARE buy path (Kalp #1416, 2026-08-26 — supersedes the SUBSCRIPTION-ONLY build of
     2026-08-25 #1354). The lane is owned by snippets/hx-sel-mode-toggle.liquid via
     window.__hxMode; this file only executes the purchase:
       sub (default) : Seal plan 2680193071 attached — fail-closed if the plan id is missing
                       ([[units-self-halt-never-self-repair]]).
       one           : no selling_plan — a missing plan is the CORRECT state in this lane.
     Direct to checkout: clear -> add (retry once) -> /checkout. The /cart/<vid>:1 permalink
     stays BANNED (drops the selling plan); the Kaching drawer stays bypassed. */
  var PLAN="2680193071";
  window.evSub=true;
  var inflight=false;
  function pause(ms){return new Promise(function(res){setTimeout(res,ms)})}
  function subMode(){return (window.__hxMode||'sub')==='sub';}
  window.evAddToCart=function(vid,qty,btn){
    if(inflight) return;
    var box=document.querySelector('.offer-box[data-variant-id="'+vid+'"],.prdoff-offer-box[data-variant-id="'+vid+'"]');
    var sub=subMode();
    var plan=sub?((box&&box.dataset.sellingPlanId)||PLAN):"";
    if(sub&&!plan){
      try{window.posthog&&posthog.capture("atc_blocked_no_plan",{variant:String(vid),offer:"everly"})}catch(_){}
      document.querySelectorAll(".loading_hk").forEach(function(b){b.classList.remove("loading_hk")});
      return;
    }
    inflight=true;
    var item={id:parseInt(String(vid),10),quantity:parseInt(qty,10)||1};
    if(plan) item.selling_plan=parseInt(plan,10);
    try{window.posthog&&posthog.capture("add_to_cart",{offer:"everly",variant_id:String(vid),purchase_type:sub?"subscription":"one_time"})}catch(_){}
    function add(){return fetch("/cart/add.js",{method:"POST",priority:"high",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[item]})})}
    fetch("/cart/clear.js",{method:"POST",priority:"high"}).then(function(){return pause(120)}).then(add)
      .then(function(r){ if(r.ok) return r; return pause(800).then(add); })
      .then(function(r){ if(!r.ok) throw 0; location.href="/checkout"; })
      .catch(function(){
        inflight=false;
        document.querySelectorAll(".loading_hk").forEach(function(b){b.classList.remove("loading_hk")});
      });
  };
  function wire(){
    var c=document.getElementById("auto-refill");c&&(c.checked=subMode());
    document.querySelectorAll(".offer-box,.prdoff-offer-box").forEach(function(o){
      if(!o.dataset.sellingPlanId&&subMode())o.dataset.sellingPlanId=PLAN;
    });
    /* the old refresh() that wrote "Refills Ship Every 30 Days" into .ss-postatc is GONE —
       Kalp #1416.5: that panel is removed now that subscribing is a choice. */
  }
  document.readyState!=="loading"?wire():document.addEventListener("DOMContentLoaded",wire)
})();
